// auto-update.service.ts
import { Injectable, inject, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AutoUpdateService {
  private swUpdate = inject(SwUpdate);
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.setupAutoUpdates();
    }
  }

  private setupAutoUpdates() {
    if (!this.swUpdate.isEnabled) {
      // Evitar logs en SSR/entornos sin SW
      return;
    }


    // Detectar y aplicar actualizaciones automáticamente
    this.swUpdate.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe(async () => {
        // console.log('🔄 Actualización detectada - Aplicando automáticamente');
        await this.applyUpdate();
      });

    // Verificar actualizaciones cada 5 minutos
    setInterval(() => {
      this.swUpdate.checkForUpdate();
    }, 300000);
  }

  private async applyUpdate() {
    try {
      // Mostrar loader simple
      this.showLoader();

      // Activar la actualización y recargar
      await this.swUpdate.activateUpdate();
      setTimeout(() => window.location.reload(), 1000);

    } catch (error) {
      console.error('Error en actualización:', error);
      this.hideLoader();
    }
  }

  private showLoader() {
    const loader = document.createElement('div');
    loader.innerHTML = `
      <div style="
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0,0,0,0.8); color: white;
        display: flex; justify-content: center; align-items: center;
        z-index: 9999; font-family: Arial;
      ">
        <div>🔄 Actualizando aplicación...</div>
      </div>
    `;
    document.body.appendChild(loader);
  }

  private hideLoader() {
    const loader = document.querySelector('div[style*="position: fixed"]');
    if (loader) loader.remove();
  }
}
